import React from 'react';

const SvgSettings = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill="currentColor"
    {...props}
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M11.945 9.429A2.571 2.571 0 1014.517 12a2.579 2.579 0 00-2.572-2.571zM18.7 12a6.507 6.507 0 01-.064.874l1.9 1.491a.454.454 0 01.1.579l-1.8 3.111a.455.455 0 01-.553.193l-2.237-.9a6.9 6.9 0 01-1.517.887l-.329 2.379a.467.467 0 01-.45.386h-3.6a.468.468 0 01-.45-.373l-.334-2.379a6.611 6.611 0 01-1.517-.887l-2.237.9a.455.455 0 01-.553-.193l-1.8-3.111a.454.454 0 01.1-.579l1.9-1.491A6.862 6.862 0 015.2 12a6.507 6.507 0 01.064-.874l-1.9-1.491a.454.454 0 01-.1-.579l1.8-3.111a.455.455 0 01.553-.193l2.237.9a6.9 6.9 0 011.517-.887L9.7 3.386A.467.467 0 0110.145 3h3.6a.468.468 0 01.45.373l.334 2.379a6.611 6.611 0 011.517.887l2.237-.9a.455.455 0 01.553.193l1.8 3.111a.454.454 0 01-.1.579l-1.9 1.491A6.862 6.862 0 0118.7 12z" />
  </svg>
);

export default SvgSettings;
